import React from 'react'
import Header from '../Components/Header/Header'
import ContactUs from '../Components/Contact/ContactUs'
function ContactUsMain() {
  return (
    <div>
        <Header></Header>
        <ContactUs></ContactUs>
    </div>
  )
}

export default ContactUsMain